import { DataEntity } from './data-entity';

export class YDataEntity extends DataEntity {
  constructor(options?: Partial<YDataEntity>) {
    super(options);

    this.dataEntityTypeCode = 'ydata';
    this.dataEntityTypeDescription = 'This Data Entity Returns the YData.';
    this.dataEntityTypeName = 'Y Data Entity';

    if (options) {
      Object.assign(this, options);
    }
  }
}
